import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { useSnapshot } from "valtio";

//internal components
import PublicHeaderNavigation from "../../../Common/Header/HeaderNavigation";
import PublicFooterNavigation from "../../../Common/Footer/FooterNavigationRefresh";
import BreadCrumbPanelNew from "../../../Common/BreadCrumbPanelNew";
import VendorNavigation from "../../../Common/VendorNavigation";
import SearchResultPremium from "../../../Common/SearchResultPremium";
import VendorCaseStudies from "../CaseStudyPremium/VendorCaseStudies";
import VendorFilter from "../../../Common/VendorFilter";
import PaginationPremium from "../../../Common/PaginationPremium";
import { EnhancedVendorCaseStudies } from "../../../../store/ValtioState";

const PremiumCaseStudyRefresh = (props) => {
  const [paginationOn, setPaginationOn] = useState(1);
  const [itemOnPage, setItemOnPage] = useState(15);
  const [isLoader, setIsLoader] = useState(false);
  const EnhancedVendorCaseStudiesSnap = useSnapshot(EnhancedVendorCaseStudies);

  useEffect(() => {
    if (!!props?.location?.pathname) {
      const accSingleTriggers = document.querySelectorAll(
        ".js-acc-single-trigger"
      );
      accSingleTriggers.forEach((trigger) =>
        trigger.addEventListener("click", toggleAccordion)
      );
      const accSingleTriggers2 = document.querySelectorAll(".acc-toggle");
      accSingleTriggers2.forEach((trigger) =>
        trigger.addEventListener("click", toggleAccordion)
      );
      function toggleAccordion() {
        const items = document.querySelectorAll(".js-acc-item");
        const thisItem = this.parentNode;
        items.forEach((item) => {
          if (thisItem === item) {
            thisItem.classList.toggle("is-open");
            return;
          }
          item.classList.remove("is-open");
        });
      }
    }
  }, [props?.location?.pathname]);

  const toggleLoader = () => {
    setIsLoader(!isLoader);
  };

  const ShowContentOnCaseStudy = (CSSnap, URLPathname) => {
    if (Object.keys(CSSnap).length > 0 && !!URLPathname) {
      let vendorSlug = URLPathname.split("/")[2];
      if (
        !![
          "appian",
          "bamboohr",
          "blackline",
          "camunda",
          "confluent",
          "adyen",
          "ansys",
          "apigee",
          "autodesk",
          "bmc-software",
        ].find((vendor) => vendor === vendorSlug)
      ) {
        return ShowCaseHardCodedCaseStudiesOverviewType1(CSSnap, URLPathname);
      } else if (
        !![
          "creatio",
          "databricks",
          "datadog",
          "dataiku",
          "demandbase",
          "bynder",
          "ceridian",
          "clevertap",
          "cloudflare",
        ].find((vendor) => vendor === vendorSlug)
      ) {
        return ShowCaseHardCodedCaseStudiesOverviewType2(CSSnap, URLPathname);
      } else if (
        !![
          "domo",
          "dwolla",
          "jumio",
          "neo4j",
          "new-relic",
          "denodo-technologies",
          "veritas-technologies",
          "postman",
          "optimizely",
          "marketo",
        ].find((vendor) => vendor === vendorSlug)
      ) {
        return ShowCaseHardCodedCaseStudiesOverviewType5(CSSnap, URLPathname);
      } else if (
        !![
          "servicenow",
          "sisense",
          "splunk",
          " wrike",
          "liveperson",
          "iterable",
          "imperva",
          "hevo-data",
          "everbridge",
        ].find((vendor) => vendor === vendorSlug)
      ) {
        return ShowCaseHardCodedCaseStudiesOverviewType4(CSSnap, URLPathname);
      } else {
        return (
          <p>
            Browse {props.vendorCommon.name} case studies and success stories to
            help make the right purchasing decision.
          </p>
        );
      }
    }
  };

  const ShowCaseHardCodedCaseStudiesOverviewType1 = (CSSnap, URLPathname) => {
    let listOfVendors = Object.keys(CSSnap);
    let nameOfVendorInURLPath = URLPathname.split("/")[2];
    if (!!listOfVendors.find((vendor) => vendor === nameOfVendorInURLPath)) {
      return (
        <>
          <h2>Case Studies Overview</h2>
          {CSSnap[nameOfVendorInURLPath].case_study_content.map(
            (CSContentObject) => (
              <>
                <h3>{CSContentObject.heading}</h3>
                <p>{CSContentObject.content}</p>
              </>
            )
          )}
        </>
      );
    } else {
      return false;
    }
  };

  const ShowCaseHardCodedCaseStudiesOverviewType2 = (CSSnap, URLPathname) => {
    let listOfVendors = Object.keys(CSSnap);
    let nameOfVendorInURLPath = URLPathname.split("/")[2];
    let leftCS = [];
    let rightCS = [];
    if (!!listOfVendors.find((vendor) => vendor === nameOfVendorInURLPath)) {
      for (
        let a = 0;
        a < CSSnap[nameOfVendorInURLPath].case_study_content.length;
        a++
      ) {
        if (!Boolean(a % 2)) {
          leftCS.push(CSSnap[nameOfVendorInURLPath].case_study_content[a]);
        } else {
          rightCS.push(CSSnap[nameOfVendorInURLPath].case_study_content[a]);
        }
      }
      return (
        <>
          <h2>Case Studies Overview</h2>
          <div class="accordion-single js-acc-single">
            <div className="left">
              {leftCS.map((content) => (
                <div class="accordion-single-item js-acc-item">
                  <h3 class="accordion-single-title js-acc-single-trigger">
                    {content.heading}
                  </h3>
                  <div class="accordion-single-content">
                    <p>{content.content}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="right">
              {rightCS.map((content) => (
                <div class="accordion-single-item js-acc-item">
                  <h3 class="accordion-single-title js-acc-single-trigger">
                    {content.heading}
                  </h3>
                  <div class="accordion-single-content">
                    <p>{content.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      );
    } else {
      return false;
    }
  };

  const ShowCaseHardCodedCaseStudiesOverviewType3 = (CSSnap, URLPathname) => {
    let listOfVendors = Object.keys(CSSnap);
    let nameOfVendorInURLPath = URLPathname.split("/")[2];
    if (!!listOfVendors.find((vendor) => vendor === nameOfVendorInURLPath)) {
      return (
        <>
          <h2>Case Studies Overview</h2>
          <div className="accordion-single js-acc-single accordion-toggle disabledHeading">
            {CSSnap[nameOfVendorInURLPath].case_study_content.map(
              (CSContentObject) => (
                <>
                  <div class="accordion-single-item js-acc-item">
                    <h3 class="accordion-single-title js-acc-single-trigger">
                      {CSContentObject.heading}
                    </h3>
                    <div class="accordion-single-content">
                      <p>{CSContentObject.content}</p>
                    </div>
                    <span class="acc-toggle"></span>
                  </div>
                </>
              )
            )}
          </div>
        </>
      );
    } else {
      return false;
    }
  };

  const ShowCaseHardCodedCaseStudiesOverviewType4 = (CSSnap, URLPathname) => {
    let listOfVendors = Object.keys(CSSnap);
    let nameOfVendorInURLPath = URLPathname.split("/")[2];
    let leftCS = [];
    let rightCS = [];
    if (!!listOfVendors.find((vendor) => vendor === nameOfVendorInURLPath)) {
      let localCopy = [...CSSnap[nameOfVendorInURLPath].case_study_content];
      let introductionContent = localCopy.slice(0, 1);
      let twobytwocolumnContent = localCopy.slice(1, 5);
      for (let a = 0; a < twobytwocolumnContent.length; a++) {
        if (!Boolean(a % 2)) {
          leftCS.push(twobytwocolumnContent[a]);
        } else {
          rightCS.push(twobytwocolumnContent[a]);
        }
      }
      return (
        <>
          <h2>Case Studies Overview</h2>
          <p>{introductionContent[0].content}</p>
          <div class="accordion-single js-acc-single">
            <div className="left">
              {leftCS.map((content) => (
                <div class="accordion-single-item js-acc-item">
                  <h3 class="accordion-single-title js-acc-single-trigger">
                    {content.heading}
                  </h3>
                  <div class="accordion-single-content">
                    <p>{content.content}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="right">
              {rightCS.map((content) => (
                <div class="accordion-single-item js-acc-item">
                  <h3 class="accordion-single-title js-acc-single-trigger">
                    {content.heading}
                  </h3>
                  <div class="accordion-single-content">
                    <p>{content.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      );
    } else {
      return false;
    }
  };

  const ShowCaseHardCodedCaseStudiesOverviewType5 = (CSSnap, URLPathname) => {
    let listOfVendors = Object.keys(CSSnap);
    let nameOfVendorInURLPath = URLPathname.split("/")[2];
    let leftCS = [];
    let rightCS = [];
    if (!!listOfVendors.find((vendor) => vendor === nameOfVendorInURLPath)) {
      for (
        let a = 0;
        a < CSSnap[nameOfVendorInURLPath].case_study_content.length - 1;
        a++
      ) {
        if (!Boolean(a % 2)) {
          leftCS.push(CSSnap[nameOfVendorInURLPath].case_study_content[a]);
        } else {
          rightCS.push(CSSnap[nameOfVendorInURLPath].case_study_content[a]);
        }
      }
      return (
        <>
          <h2>Case Studies Overview</h2>
          <div class="accordion-single js-acc-single accordion-toggle disabledHeading">
            <div className="left">
              {leftCS.map((content) => (
                <div class="accordion-single-item js-acc-item">
                  <h3 class="accordion-single-title js-acc-single-trigger">
                    {content.heading}
                  </h3>
                  <div class="accordion-single-content">
                    <div className="accordion-single-content">
                      <p>{content.content}</p>
                    </div>
                  </div>
                  <span class="acc-toggle"></span>
                </div>
              ))}
            </div>
            <div className="right">
              {rightCS.map((content) => (
                <div class="accordion-single-item js-acc-item">
                  <h3 class="accordion-single-title js-acc-single-trigger">
                    {content.heading}
                  </h3>
                  <div class="accordion-single-content">
                    <div className="accordion-single-content">
                      <p>{content.content}</p>
                    </div>
                  </div>
                  <span class="acc-toggle"></span>
                </div>
              ))}
            </div>
          </div>
        </>
      );
    } else {
      return false;
    }
  };

  return (
    <>
      <PublicHeaderNavigation />

      <BreadCrumbPanelNew
        breadcrumbs={props.vendorCaseStudies?.breadcrumb_links}
      />
      <section class="vendor_page_header_section">
        <div class="container">
          <div class="cls_back">
            <Link to={props.vendorCommon.profile_url}>Back to Profile</Link>
          </div>
          <div class="vendor_page_main_heading">
            <h1>{`${props.vendorCommon.casestudy_count} ${props.vendorCommon.name} Case Studies`}</h1>
          </div>
        </div>
      </section>

      <div class="vendor_portal_filter_section">
        {/* <SearchResultPremium
            totalReviewCount={props.vendorCaseStudies.total_reviews_count}
            paginationInfo={props.vendorCaseStudies.pagination}
            paginationOn={paginationOn}
            itemOnPage={itemOnPage}
            reviewCount={props.vendorCaseStudies.total_reviews_count}
          /> */}
        <div className="container">
          <VendorFilter
            sizeOptions={props?.vendorCaseStudies?.company_size_options || []}
            industryOptions={props?.vendorCaseStudies?.industry_options || []}
            sortByOptions={props.vendorCaseStudies.sort_by_options}
            productOptions={props.vendorCaseStudies.product_options}
            paginationInfo={props.vendorCaseStudies.pagination}
          />
        </div>
      </div>

      <section>
        <div className="middleSection vendor_case_studies_section">
          <div className="container">
            <div className="vendor_reviews_section case_study">
              <div className="case_study_reviews">
                <VendorCaseStudies {...props} />
              </div>
            </div>
            <PaginationPremium
              {...props}
              paginationOn={paginationOn}
              setPaginationOn={setPaginationOn}
              itemOnPage={itemOnPage}
              setItemOnPage={setItemOnPage}
              pageData={Array.apply(
                null,
                Array(props?.vendorCaseStudies?.pagination?.num_pages)
              ).map((val, idx) => ({ page: idx + 1 }))}
              paginationInfo={props.vendorCaseStudies.pagination}
              toggleLoader={toggleLoader}
            />
            {/* <section className="vendor_block_section">
              <div className="vendor_profile_main_content_block case_studies">
                <div className="vendor_case_studies_content_block">
                  <div className="vendor_portal_top_header_block">
                    <h1>{`${props.vendorCommon.name} Case Studies`}</h1>
                    {ShowContentOnCaseStudy(
                      EnhancedVendorCaseStudiesSnap,
                      props?.location?.pathname
                    )}
                  </div>
                </div>
              </div>
            </section> */}
          </div>
        </div>
      </section>

      <PublicFooterNavigation />
    </>
  );
};
const PremiumCaseStudyRefreshWithRouter = withRouter(PremiumCaseStudyRefresh);
const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
    vendorCaseStudies: state.vendorCaseStudies,
  };
};

export default connect(mapStateToProps)(PremiumCaseStudyRefreshWithRouter);
